<!--
 * @Author: wangjiaxiang
 * @Date: 2022-03-21 14:36:31
 * @LastEditTime: 2022-04-25 11:23:30
 * @LastEditors: wangjiaxiang
 * @Description: 
 * @FilePath: /xingmahui_front/src/views/contents/babyWikipedia/index.vue
 * 
-->
<template>
  <div>
    <keep-alive :include="includes" :max="5">
      <router-view></router-view>
    </keep-alive>
  </div>
</template>

<style lang="less" scoped>
</style>

<script>
import { mapState } from "vuex";

export default {
  name: "wikipediaIndex",
  components: {},
  data() {
    return {};
  },
  computed: {
    // 在computed中动态监控
    ...mapState({
      includes: (state) => state.includes,
    }),
  },
  mounted() {
  },
  created() {},
  methods: {},
};
</script>
